import { useCallback, useState } from 'react'

import { useWindowResize } from '@utils/domUtils'

import { detectAndroidOperatingSystem, detectIOSOperatingSystem } from '@model/PlatformTypeEnum'
import { DemoTradingAccount, TradingAccount } from '@model/TradingAccount'

import { usePlatformTradeUrl } from '@hooks/usePlatformTradeUrl'

import { useTradingViewPlatformLinks } from './useTradingViewPlatformLinks'

export type TradingViewTradeButtonParams = {
  account: TradingAccount | DemoTradingAccount
}

export type TradingViewTradeButtonState = {
  isLoading: boolean
  handleClick: () => void
}

export const useTradingViewTradeButton = ({
  account,
}: TradingViewTradeButtonParams): TradingViewTradeButtonState => {
  const isMobile = useWindowResize()
  const { getPlatformTradeUrl } = usePlatformTradeUrl()
  const { iosLink, androidLink } = useTradingViewPlatformLinks()
  const [isLoading, setIsLoading] = useState(false)

  const handleClick = useCallback(async () => {
    if (isLoading) return

    setIsLoading(true)

    try {
      const newWindow = window.open('about:blank', '_blank')

      if (isMobile) {
        const isIOS = detectIOSOperatingSystem()
        const isAndroid = detectAndroidOperatingSystem()

        const mobileUrl = isIOS ? iosLink : isAndroid ? androidLink : undefined

        if (mobileUrl && newWindow) {
          newWindow.location.href = mobileUrl
          return
        }
      }

      const platformTradeUrl = await getPlatformTradeUrl(account)

      if (platformTradeUrl && newWindow) {
        newWindow.location.href = platformTradeUrl
      }
    } finally {
      setIsLoading(false)
    }
  }, [account, androidLink, getPlatformTradeUrl, iosLink, isLoading, isMobile])

  return {
    isLoading,
    handleClick,
  }
}
